/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, Input, OnInit, OnChanges, ViewChild} from '@angular/core';
import { ServerObjectService } from '../../services/server-object.service';
import {ServiceService} from "../../services/service.service";
import {ServerObjectInstance} from "../../models/server-object-instance";
import {NgxSpinnerService} from "ngx-spinner";
import { ERROR_DIALOG_TITLE, SimpleSuccessErrorDialogComponent } from '../simple-success-error-dialog-box/simple-success-error-dialog-box.component';

declare var $: any;

@Component({
  selector: 'app-settings-licensing',
  templateUrl: './settings.licensing.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsLicensingComponent implements OnInit, OnChanges {

  /** Reference to the SimpleSuccessErrorDialog used to display error */
  @ViewChild('successErrorDialog') 
  simpleSuccessErrorDialogComponent: SimpleSuccessErrorDialogComponent;

  @Input() serverObjectInstance: ServerObjectInstance;
  @Input() license_email_address = null;
  @Input() license_email_days: number;

  constructor(private services: ServiceService, private serverObjectService: ServerObjectService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {

  }

  ngOnChanges(): void {
    if (this.serverObjectInstance) {
      console.log("SettingsLicensingComponent: " + this.license_email_address + ", " + this.license_email_days);
    }
  }

  updateSettingsLicensing(): void {
    this.spinner.show();

    for(const dataElement of this.serverObjectInstance.data) {
      if (dataElement.property && dataElement.property.property) {
        if (dataElement.property.property == "licensing_email_addresses") {
          dataElement.value = this.license_email_address;
          dataElement.object_value = this.license_email_address;
        }
        if (dataElement.property.property == "licensing_expire_num_days") {
          dataElement.value = "" + this.license_email_days;
          dataElement.object_value = this.license_email_days;
        }
      }
    }

    this.serverObjectService.updateServerObjectInstance(this.serverObjectInstance).then(
        response => {
          console.log("update serverObjectInstance successful");
          this.spinner.hide();
        },
        error => {
          this.spinner.hide();
          this.handleError(error);
        }
      );
  }

  handleError(error: any): void {
    console.error("handleError() - Error: " + error);
    if (error != null) {
      const response: Response = error;
      this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, response.text().toString());
    }
  }
}
